import React from 'react'

const HubPageTitle = ({children, ...rest}) => {
  return (
    <h3 className='w-100 text-center' style={{color: 'var(--blue)'}}>{children}</h3>
  )
}

export default React.memo(HubPageTitle);
